import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { CustomerTeam, CustomerTeamCreateUpdateModel } from "../model";
import { CREATE_CUSTOMER_TEAM } from "../actionTypes";
import { createCustomerTeam } from "../actions";
import { selectors as customersSelectors } from "../../customer";
import { basePathSelector } from "../selectors";

import { CreateEditModal } from "./CreateEditModal";

import { push } from "redux-little-router";

interface Props {
    teams: CustomerTeam[];
}

export const Create: React.FunctionComponent<Props> = ({ teams }) => {
    const customerId = useSelector(customersSelectors.routeIdSelector);
    const dispatch = useDispatch();
    const saveTeam = React.useCallback((model: CustomerTeamCreateUpdateModel) => {
        return dispatch(createCustomerTeam(customerId, model));
    }, [customerId, dispatch]);
    const basePath = useSelector(basePathSelector);
    const onClose = React.useCallback(() => dispatch(push(basePath, {})), [basePath, dispatch]);
    return (<CreateEditModal
        title="Create Customer Team"
        onSave={saveTeam}
        isSavingRequestName={CREATE_CUSTOMER_TEAM}
        defaultValues={{ name: "", memberIds: [] }}
        onClose={onClose}
        teams={teams}
    />);
};
